import Environment from '../Utils/Environment.js'
import Raycast from '../Raycast.js'
import Audio from '../Audio.js'
//
import Kaart from './Kaart.js'
import Models_world from './Models_world.js'
import Route from './Route.js'

export default class World {
    constructor(controller) {
        this.controller = controller
        this.scene = this.controller.scene
        this.resources = this.controller.resources

        // Wait for resources
        this.controller.stateController.resources.on('ready', () => {
            //Setup
            this.kaart = new Kaart(this.controller)
            this.models_world = new Models_world(this.controller)
            this.route = new Route(this.controller)
            //
            this.audio = new Audio(this.controller)
            this.environment = new Environment(this.controller)
            this.raycast = new Raycast(this.controller)
        })
    }

    // Update zodat de animatie afspeelt
    update() {
        if (this.kaart) this.kaart.update()
        if (this.models_world) this.models_world.update()
        if (this.route) this.route.update()
        //
        if (this.audio) this.audio.update()
        if (this.environment) this.environment.update()
        if (this.raycast) this.raycast.update()
    }
}